import { useMutation } from '@tanstack/react-query';
import { initiateInstantPayout } from '../../services/business';
import useBusiness from '../businesses/useBusiness';

interface Params {
  onSuccess?: (
    result: Awaited<ReturnType<typeof initiateInstantPayout>>,
  ) => void;
  onError?: (error: Error) => void;
  onMutate?: () => void;
  onSettled?: () => void;
}

function useInitiatePayout({
  onSuccess,
  onError,
  onMutate,
  onSettled,
}: Params = {}) {
  const { business } = useBusiness();

  return useMutation({
    mutationFn: async (amount: number) => {
      if (!business) throw new Error('Business not found');

      const response = await initiateInstantPayout(business.id, amount);

      return response;
    },
    onSuccess,
    onError,
    onMutate,
    onSettled,
  });
}

export default useInitiatePayout;
